import React from "react";
import { useNavigate } from "react-router-dom";
import ContainedButton from "components/Ui/ContainedButton";
const Ferme1 = () => {
  const navigate = useNavigate();
  const navigateToCreateCaheir = () => {
    navigate("/cahier-sheet/cahier-steps");
  };
  return (
    <ContainedButton
      contentText={"Créer un Journal de caisse"}
      OnClick={navigateToCreateCaheir}
    />
  );
};
export default Ferme1;
